import { CSS, Transform } from '@dnd-kit/utilities';

interface SortableTreeItemSxProps {
  transform: Transform | null;
  transition: string | undefined;
  isDragging: boolean;
}

export function getSortableTreeItemSx({
  transform,
  transition,
  isDragging,
}: SortableTreeItemSxProps): Record<string, unknown> {
  return {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    paddingLeft: 0,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  };
}
